import styled from "styled-components"

export const SpinnerSC = styled.div<{ height?: string }>`
  height: ${(props) => props.height || '100vh'};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;